<template>
    <div>
    <header>
            <div>
                <h2 class="header_side_eng">{{ recordtoshow.nameeng }}</h2>
                <h2 class="header_side_ch">{{ recordtoshow.namech }}</h2>
            </div>
            <div>
                <span class="header_side_idtag">{{ recordtoshow.recordid }}</span>
            </div>
    </header>
    <section class="mainbody">
        <!-- DATA SECTION: PARAGRAPH -->
        <section class="data_module" v-if="recordtoshow.type">
            <h4 class="data_title"><span class="data_title_ch">類別</span> <span class="data_title_eng">Type</span></h4>
            <p class="data_eng">{{ recordtoshow.type }}</p>
        </section>
        <!-- DATA SECTION: PARAGRAPH -->
        <section class="data_module" v-if="recordtoshow.author">
            <h4 class="data_title"><span class="data_title_ch">作者</span> <span class="data_title_eng">Author</span></h4>
            <p class="data_eng">{{ recordtoshow.author }}</p>
        </section>
        <!-- DATA SECTION: PARAGRAPH -->
        <section class="data_module" v-if="recordtoshow.date">
            <h4 class="data_title"><span class="data_title_ch">日期</span> <span class="data_title_eng">Date</span></h4>
            <p class="data_eng">{{ recordtoshow.date }}</p>
        </section>
        <!-- DATA SECTION: PARAGRAPH -->
        <section class="data_module" v-if="recordtoshow.citation">
            <h4 class="data_title"><span class="data_title_ch">參考文獻</span> <span class="data_title_eng">Citation</span></h4>
            <p class="data_eng" v-html="recordtoshow.citation"></p>
        </section>
        <!-- DATA SECTION: URL-->
        <section class="data_module" v-if="recordtoshow.url">
                <h4 class="data_title"><span class="data_title_ch"> 網址</span> <span class="data_title_eng">URL</span></h4>
                <p class="data_eng"><a :href="recordtoshow.url" target="_blank">{{ recordtoshow.url }}</a></p>
        </section>
        <!-- DATA SECTION: PARAGRAPH -->
        <section class="data_module" v-if="recordtoshow.note">
            <h4 class="data_title"><span class="data_title_ch">註解 </span> <span class="data_title_eng">Notes</span></h4>
            <p class="data_eng" v-html="recordtoshow.note"></p>
        </section>
        <!-- DATA SECTION: PARAGRAPH -->
        <section class="data_module" v-if="recordtoshow.footnote">
            <h4 class="data_title"><span class="data_title_ch">註腳 </span> <span class="data_title_eng">Footnotes</span></h4>
            <p class="data_eng" v-html="recordtoshow.footnote"></p>
        </section>

    </section>
    </div>
</template>

<script>

export default {
    name: 'RecordResource',
    props: {
        recordtoshow: Object
    }
}
</script>